// Generated by `npm run data:marlin-tags` (scripts/data/marlinTags.ts) from data/swfsc-billfish-tags/ (NOAA SWFSC's
// Billfish Tagging Program on NOAA's ERDDAP, free use and redistribution). Do not edit by hand.
import type { MarlinTags } from '../marlin';

/** The Pacific blue marlin anglers tagged, and where those tagged off Hawaii were caught again (M108). */
export const MARLIN_TAGS: MarlinTags = {"released":15981,"firstYear":1964,"lastYear":2021,"hawaiiRecaptured":68,"southOfEquator":5,"northOf40":0,"within200Nmi":46,"past1000Nmi":12,"farthestKm":8246};
